import type { Location, LocationCategory } from '../types/location.js';

/**
 * Utility for mapping between Supabase Database rows and Frontend Location objects.
 * Locations are technically 'tags' with tag_type='location' in the database.
 */

export const dbRowToLocation = (row: any): Location => {
  const metadata = row.metadata || {};
  return {
    id: row.id,
    name: row.name,
    teamId: row.team_id,
    sortOrder: row.sort_order ?? 0,
    category: (metadata.category as LocationCategory) || 'home',
    createdAt: new Date(row.created_at),
    currentStateId: row.current_state_id,
    state: row.state ? {
      id: row.state.id,
      teamId: row.state.team_id,
      tagId: row.state.tag_id || null,
      stateGroupId: row.state.state_group_id || null,
      name: row.state.name,
      emoji: row.state.emoji,
      color: row.state.color,
      isOptimal: row.state.is_optimal,
      sortOrder: row.state.sort_order ?? null,
      createdAt: new Date(row.state.created_at),
    } : null,
    latitude: metadata.latitude ?? row.latitude,
    longitude: metadata.longitude ?? row.longitude,
    radius: metadata.radius ?? row.radius,
    isGeofencingEnabled: metadata.is_geofencing_enabled ?? row.is_geofencing_enabled,
  };
};

export const mapLocationToDb = (updates: Partial<Location>): any => {
  const dbUpdates: any = {};
  
  if ('name' in updates && updates.name !== undefined) dbUpdates.name = updates.name.trim();
  if ('teamId' in updates) dbUpdates.team_id = updates.teamId;
  if ('sortOrder' in updates) dbUpdates.sort_order = updates.sortOrder;
  if ('currentStateId' in updates) dbUpdates.current_state_id = updates.currentStateId;
  
  if ('latitude' in updates) dbUpdates.latitude = updates.latitude;
  if ('longitude' in updates) dbUpdates.longitude = updates.longitude;
  if ('radius' in updates) dbUpdates.radius = updates.radius;
  if ('isGeofencingEnabled' in updates) dbUpdates.is_geofencing_enabled = updates.isGeofencingEnabled;
  
  if ('category' in updates) {
    dbUpdates.metadata = { category: updates.category };
    dbUpdates.tag_type = 'location';
  }
  
  return dbUpdates;
};
